class FloatingFreeShippingPopup {
  constructor() {
    this.popup = document.querySelector('[data-floating-free-shipping-popup]');
    if (!this.popup) return;

    this.textEl = this.popup.querySelector('[data-floating-free-shipping-text]');
    this.progressEl = this.popup.querySelector('[data-floating-free-shipping-progress]');
    this.giftMilestone = this.popup.querySelector('[data-floating-gift-milestone]');
    this.shippingMilestone = this.popup.querySelector('[data-floating-shipping-milestone]');

    this.threshold = Number(this.popup.dataset.freeShippingThreshold || 6000);
    this.giftThreshold = Number(this.popup.dataset.giftThreshold || 2500);

    this.moneyFormat = window.Shopify?.money_format || '${{amount}}';
    this.hideTimeout = null;
    this.previousItemCount = null;

    this.init();
  }

  init() {
    this.refresh(true);

    document.addEventListener('cart:refresh', () => {
      this.refresh();
    });

    document.addEventListener('click', (event) => {
      if (
        event.target.closest('button[type="submit"][name="add"]') ||
        event.target.closest('[name="add"]')
      ) {
        this.waitForCartUpdate();
      }
    });
  }

  async waitForCartUpdate(retries = 6, delay = 400) {
    const previousCount = this.previousItemCount ?? 0;

    for (let i = 0; i < retries; i++) {
      await new Promise((resolve) => setTimeout(resolve, delay));

      try {
        const response = await fetch('/cart.js', { cache: 'no-store' });
        const cart = await response.json();
        const itemCount = Number(cart.item_count || 0);

        if (itemCount > previousCount) {
          this.update(cart);
          return;
        }
      } catch (error) {
        console.error('Waiting for cart update failed:', error);
      }
    }

    this.refresh();
  }

  async refresh(isInitial = false) {
    if (window.innerWidth >= 750) return;

    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await response.json();
      this.update(cart, isInitial);
    } catch (error) {
      console.error('Floating free shipping popup update failed:', error);
    }
  }

  update(cart, isInitial = false) {
    const itemCount = Number(cart.item_count || 0);
    const total = Number(cart.original_total_price || 0);

    const remainingToGift = Math.max(this.giftThreshold - total, 0);
    const remainingToShipping = Math.max(this.threshold - total, 0);

    const progress = this.threshold > 0
      ? Math.min((total / this.threshold) * 100, 100)
      : 0;

    if (this.progressEl) {
      this.progressEl.style.width = `${progress}%`;
    }

    this.updateMilestone(this.giftMilestone, total >= this.giftThreshold, {
      inactiveIcon: '🎁',
      activeIcon: '✓',
      inactiveLabel: '25 €',
      activeLabel: '✓'
    });

    this.updateMilestone(this.shippingMilestone, total >= this.threshold, {
      inactiveIcon: '🚚',
      activeIcon: '✓',
      inactiveLabel: '60 €',
      activeLabel: '✓'
    });

    if (this.textEl) {
      if (total < this.giftThreshold) {
        this.textEl.innerHTML = `🎁 Ilmainen kristalli yli 25€<br>Lisää vielä <strong>${this.formatMoney(remainingToGift)}</strong> 💜`;
      } else if (total < this.threshold) {
        this.textEl.innerHTML = `🎁 Ilmainen kristalli lisätty koriin<br>Lisää vielä <strong>${this.formatMoney(remainingToShipping)}</strong> ilmaiseen toimitukseen 🚚`;
      } else {
        this.textEl.innerHTML = `🎁 Ilmainen kristalli + ilmainen toimitus aktivoitu 💜`;
      }
    }

    if (isInitial) {
      this.previousItemCount = itemCount;
      this.hide(true);
      return;
    }

    const itemCountIncreased =
      this.previousItemCount !== null && itemCount > this.previousItemCount;

    if (itemCountIncreased) {
      this.showForFiveSeconds();
    }

    if (itemCount === 0) {
      this.hide(true);
    }

    this.previousItemCount = itemCount;
  }

  updateMilestone(milestone, isActive, content) {
    if (!milestone) return;

    milestone.classList.toggle('is-active', isActive);

    const dot = milestone.querySelector('.floating-free-shipping-popup__milestone-dot');
    const label = milestone.querySelector('.floating-free-shipping-popup__milestone-label');

    if (dot) {
      dot.textContent = isActive ? content.activeIcon : content.inactiveIcon;
    }

    if (label) {
      label.textContent = isActive ? content.activeLabel : content.inactiveLabel;
    }
  }

  showForFiveSeconds() {
    clearTimeout(this.hideTimeout);

    this.popup.classList.remove('hidden');
    this.popup.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(() => {
      this.popup.classList.add('is-visible');
    });

    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, 3000);
  }

  hide(force = false) {
    clearTimeout(this.hideTimeout);
    this.popup.classList.remove('is-visible');
    this.popup.setAttribute('aria-hidden', 'true');

    if (force) {
      this.popup.classList.add('hidden');
      return;
    }

    setTimeout(() => {
      if (!this.popup.classList.contains('is-visible')) {
        this.popup.classList.add('hidden');
      }
    }, 250);
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('fi-FI', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }) + ' €';
  }
}

window.floatingFreeShippingPopup = new FloatingFreeShippingPopup();